@if (showAmpDimEnabled) {
  <div class="col-2 custom-button">
    <div class="signifyBookmd ml-15">Enable feature<input type="checkbox"
      [checked]="isEnableFeature" [(ngModel)]="ngModelval['AmpDimEnabledVal']" name="RAmpDimset"
      class="primary-checkbox" id="RAmpDimset" (change)="enableFeatureChanged($event.target.checked)" />
      <label class="enable-feature" for="RAmpDimset"><span id="AmpDim-enable-feature-checkbox" class="extra-border-enablefeat"></span></label>
    </div>
  </div>
}
<div [ngClass]="{'disbaleStyle': ampDimDisabled && showAmpDimEnabled}">
  @if (!quickConfigvalue) {
    <app-apm-dim-graph></app-apm-dim-graph>
  }
</div>
<div class="row slider-container" [ngClass]="{'dtldisbaled': ampDimDisabled && showAmpDimEnabled}">
  <div class="col-1 text-mindim pdl-0 pdr-20">Low</div>
  @if (quickConfigvalue) {
    <div class="col-2">
      <div class="row">
        <div class="col-2"></div>
        <div class="col-2 minValMargin">
          <span class=" signifyBookmd minValue"> min {{StopDimLevelMin}}</span>
        </div>
        <div class="col-3">
          <span class="signifyBookmd maxValue"> max {{StopDimLevelMax}}</span>
        </div>
      </div>
    </div>
  }

  @if (!quickConfigvalue) {
    <span
    class="signifyBookmd text-mindim sliderMinValue col-1">{{StopDimLevelMin}}</span>
  }
  @if (!quickConfigvalue) {
    <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': ampDimDisabled && showAmpDimEnabled}" id="sliderClick">
      <ngx-slider type="normalType" [options]=StopDimLevelOption [(value)]=StopDimLevelValue
        (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="StopDimLevelValueChange($event.value)"
        ngDefaultControl>
      </ngx-slider>
    </div>
  }
  @if (!quickConfigvalue) {
    <span
    class="signifyBookmd text-mindim  col-1 maxValueCss marginTextBoxes">{{StopDimLevelMax}}</span>
  }

  <div class="input-unit-container col-3">

    <input type="number" [value]="StopDimLevelDisplayValue"
      (input)="onFieldInput($event.target.value, 'StopDimLevelValue')" id="apmDim_Low_txtbox"
      (keypress)="numberOnly($event)"
      [ngClass]="{'showingError': inputError['StopDimLevelValue']===true,  'inputCssStandard': quickConfigvalue===true}"
      class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
      [disabled]="ampDimDisabled && showAmpDimEnabled" />
      <span class="unit signifyBookmd">%</span>
    </div>
  </div>
  <div class="row slider-container" [ngClass]="{'dtldisbaled': ampDimDisabled && showAmpDimEnabled}">
    <div class="col-1 text-mindim pdl-7">Low V</div>
    @if (quickConfigvalue) {
      <div class="col-2">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-2 minValMargin">
            <span class=" signifyBookmd minValue"> min {{VmainsStopMin}}</span>
          </div>
          <div class="col-3">
            <span class="signifyBookmd maxValue"> max {{VmainsStopMax}}</span>
          </div>
        </div>
      </div>
    }

    @if (!quickConfigvalue) {
      <span
      class="signifyBookmd text-mindim sliderMinValue col-1">{{VmainsStopMin}}</span>
    }
    @if (!quickConfigvalue) {
      <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': ampDimDisabled && showAmpDimEnabled}" [id]="'sliderClick'">
        <ngx-slider type="normalType" [options]=VmainsStopOption [(value)]=VmainsStopValue
          (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="VmainsStopValueChange($event.value)"
          ngDefaultControl>
        </ngx-slider>
      </div>
    }
    @if (!quickConfigvalue) {
      <span class="signifyBookmd text-mindim  col-1 maxValueCss marginTextBoxes">{{VmainsStopMax}}</span>
    }

    <div class="input-unit-container col-3">
      <input type="number" [value]="VmainsStopDisplayValue"
        (input)="onFieldInput($event.target.value, 'VmainsStopValue')" id="apmDim_LowV_txtbox"
        (keypress)="numberOnly($event)"
        [ngClass]="{'showingError': inputError['VmainsStopValue']===true,  'inputCssStandard': quickConfigvalue===true}"
        class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
        [disabled]="ampDimDisabled && showAmpDimEnabled" />
        <span class="unit signifyBookmd">V</span>
      </div>
    </div>


    <div class="row slider-container" [ngClass]="{'dtldisbaled': ampDimDisabled && showAmpDimEnabled}">
      <div class="col-1 text-mindim pdl-0 pdr-20">High</div>
      @if (quickConfigvalue) {
        <div class="col-2">
          <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
              <span class=" signifyBookmd minValue"> min {{StartDimLevelMin}}</span>
            </div>
            <div class="col-3">
              <span class="signifyBookmd maxValue"> max {{StartDimLevelMax}}</span>
            </div>
          </div>
        </div>
      }

      @if (!quickConfigvalue) {
        <span
        class="signifyBookmd text-mindim  sliderMinValue col-1">{{StartDimLevelMin}}</span>
      }
      @if (!quickConfigvalue) {
        <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': ampDimDisabled && showAmpDimEnabled}" [id]="'sliderClick'">
          <ngx-slider type="normalType" [options]=StartDimLevelOption [(value)]=StartDimLevelValue
            (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="StartDimLevelValueChange($event.value)"
            ngDefaultControl>
          </ngx-slider>
        </div>
      }
      @if (!quickConfigvalue) {
        <span
        class="signifyBookmd text-mindim  col-1 maxValueCss marginTextBoxes">{{StartDimLevelMax}}</span>
      }

      <div class="input-unit-container col-3">
        <input type="number" [value]="StartDimLevelDisplayValue"
          (input)="onFieldInput($event.target.value, 'StartDimLevelValue')" id="apmDim_High_txtbox"
          (keypress)="numberOnly($event)"
          [ngClass]="{'showingError': inputError['StartDimLevelValue']===true,  'inputCssStandard': quickConfigvalue===true}"
          class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
          [disabled]="ampDimDisabled && showAmpDimEnabled" />
          <span class="unit signifyBookmd">%</span>
        </div>
      </div>

      <div class="row slider-container" [ngClass]="{'dtldisbaled': ampDimDisabled && showAmpDimEnabled}">
        <div class="col-1 text-mindim pdl-7">High V</div>
        @if (quickConfigvalue) {
          <div class="col-2">
            <div class="row">
              <div class="col-2"></div>
              <div class="col-2 minValMargin">
                <span class=" signifyBookmd minValue"> min {{VmainsStartMin}}</span>
              </div>
              <div class="col-3">
                <span class="signifyBookmd maxValue"> max {{VmainsStartMax}}</span>
              </div>
            </div>
          </div>
        }

        @if (!quickConfigvalue) {
          <span
          class="signifyBookmd text-mindim  sliderMinValue col-1">{{VmainsStartMin}}</span>
        }
        @if (!quickConfigvalue) {
          <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': ampDimDisabled && showAmpDimEnabled}" [id]="'sliderClick'">
            <ngx-slider type="normalType" [options]=VmainsStartOption [(value)]=VmainsStartValue
              (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="VmainsStartValueChange($event.value)"
              ngDefaultControl>
            </ngx-slider>
          </div>
        }
        @if (!quickConfigvalue) {
          <span class="signifyBookmd text-mindim  col-1 maxValueCss marginTextBoxes">{{VmainsStartMax}}</span>
        }

        <div class="input-unit-container col-3">
          <input type="number" [value]="VmainsStartDisplayValue"
            (input)="onFieldInput($event.target.value, 'VmainsStartValue')" id="apmDim_HighV_txtbox"
            (keypress)="numberOnly($event)"
            [ngClass]="{'showingError': inputError['VmainsStartValue']===true,  'inputCssStandard': quickConfigvalue===true}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="ampDimDisabled && showAmpDimEnabled" />
            <span class="unit signifyBookmd">V</span>
          </div>
        </div>
